var _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "553.505px",
    height: "524.771px",
    viewBox: "290.495 104.766 553.505 524.771",
    enableBackground: "new 290.495 104.766 553.505 524.771",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M697.396,540.479c0,41.713-33.875,75.567-75.646,75.567H379.63c-41.775,0-75.646-33.844-75.646-75.567 V298.646c0-41.719,33.875-75.573,75.646-75.573h242.12c41.776,0,75.646,33.833,75.646,75.573V540.479z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 290.099,
    y: 209.333,
    width: 421.901,
    height: 420.432
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M621.75,629.536H379.63c-49.141,0-89.135-39.942-89.135-89.057V298.646 c0-49.099,39.99-89.047,89.135-89.047h242.12c49.151,0,89.141,39.953,89.141,89.047v241.849 C710.891,589.594,670.901,629.536,621.75,629.536z M379.63,236.557c-34.275,0-62.15,27.854-62.15,62.083v241.839 c0,34.244,27.88,62.083,62.15,62.083h242.12c34.276,0,62.156-27.839,62.156-62.083V298.646c0-34.214-27.886-62.083-62.156-62.083 L379.63,236.557z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 340,
    y: 104.766,
    width: 504,
    height: 452.567
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#154854",
    d: "M828.708,104.766l-23.13,11.745c-120.989,61.422-255.229,203.693-328.63,324.005 c-7.172-13.364-9.303-17.745-16.021-32.505c-28.594-51.308-67.344-97.183-86.281-114.75l-34.391,9.412l0.792,2.063 c19.308,27.542,51.719,87.303,95.567,215.411c2.979,5.656,6.188,11.287,10.011,16.589c10.031,13.974,21.636,18.167,29.609,19.214 c0.005,0,0.005,0,0.005,0c22.745,2.953,38.49-13.234,50.448-33.016c88.479-213.261,249.281-347.094,317.052-391.292 L828.708,104.766z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.26d533552df9710e1f05115d5c754778.svg";
export { ForwardRef as ReactComponent };